import React from "react";
import {ConnectToMastodon} from "../ui/ConnectToMastadon";
import {ConnectToBlueSky} from "../ui/ConnectToBluesky";
import {ConnectToInstagram} from "../ui/ConnectToInstagram";
import {ConnectToThreads} from "../ui/ConnectToThreads";
import StripeBadge from "../ui/PoweredByStripe";

export default function Footer() {
    return (
        <footer className="bg-primary text-text-headerfooter px-4 py-6 md:min-h-[80px]">
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        "name": "Queetstone",
                        "url": "https://www.queetstone.com",
                        "logo": "https://images.queetstone.com/QueetstoneLogoRectangular.jpg",
                        "hasMerchantReturnPolicy": {
                            "@type": "MerchantReturnPolicy",
                            "name": "Queetstone Standard Return Policy",
                            "returnPolicyCategory": "https://schema.org/ReturnByMail",
                            "returnMethod": "https://schema.org/Mail",
                            "merchantReturnDays": 30,
                            "returnFees": "https://schema.org/FreeReturn",
                            "url": "https://www.queetstone.com/return-policy"
                        }
                    }),
                }}
            />
            <div className="max-w-6xl mx-auto">
                <div data-testid='footer-mobile' className="flex flex-col gap-8 md:hidden mt-6">
                    <div>
                        <h3 className="font-bold text-lg uppercase tracking-wide mb-2">Queetstone</h3>
                        <p>720 Seneca St Ste 107</p>
                        <p>#490</p>
                        <p>Seattle, WA 98101</p>
                    </div>

                    <div>
                        <h3 className="font-bold text-lg uppercase tracking-wide mb-2">About</h3>
                        <ul className="flex flex-col gap-1">
                            <li><a href="/about-us" className="hover:underline">About Us</a></li>
                            <li><a href="/faq" className="hover:underline">FAQ</a></li>
                            <li><a href="/privacy-policy" className="hover:underline">Privacy Policy</a></li>
                            <li><a href="/terms-of-use" className="hover:underline">Terms of Use</a></li>
                            <li><a href="/return-policy" className="hover:underline">Return Policy</a></li>
                            <li><a href="/shipping-policy" className="hover:underline">Shipping Policy</a></li>
                            <li><a href="/contactus" className="hover:underline">Contact Us</a></li>
                        </ul>
                    </div>

                    <div>
                        <h3 className="font-bold text-lg uppercase tracking-wide mb-2">Connect</h3>
                        <div className="flex gap-3">
                            <ConnectToMastodon size={28}/>
                            <ConnectToBlueSky size={28}/>
                            <ConnectToInstagram size={28}/>
                            <ConnectToThreads size={28}/>
                        </div>
                    </div>
                </div>

                <div data-testid='footer-desktop' className="hidden md:flex justify-between items-center">
                    <div className="text-sm">
                        <span className="font-semibold tracking-wide uppercase">Queetstone</span>
                    </div>

                    <div className="flex gap-6 text-sm">
                        <a href="/about-us" className="hover:underline">About</a>
                        <a href="/faq" className="hover:underline">FAQ</a>
                        <a href="/privacy-policy" className="hover:underline">Privacy</a>
                        <a href="/terms-of-use" className="hover:underline">Terms</a>
                        <a href="/shipping-policy" className="hover:underline">Shipping</a>
                        <a href="/return-policy" className="hover:underline">Return Policy</a>
                        <a href="/contactus" className="hover:underline">Contact</a>
                    </div>

                    <div className="flex gap-3">
                        <ConnectToMastodon size={22}/>
                        <ConnectToBlueSky size={22}/>
                        <ConnectToInstagram size={22}/>
                        <ConnectToThreads size={22}/>
                    </div>
                </div>

                <div className="mt-3 flex md:justify-center">
                    <StripeBadge width={120}/>
                </div>

                <div className="text-center text-xs mt-5 md:mt-2">
                    &copy; 2025 Queetstone. All rights reserved. Queetstone is a trade name of QA Flex LLC.
                </div>
            </div>
        </footer>
    );
}
